const toFixedNumber = value => {
    return Number.parseFloat(value || 0).toFixed(2) || '';
};

export {
    toFixedNumber
};
